import styled, { css } from 'styled-components';

import { FiltersForm } from '@xing-com/crate-people-directory-filters-form';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, spaceL, scale110 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ContentPlaceholder = styled.div`
  min-height: 80vh;
`;

const marginCss = css`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;

export const StyledHeadline = styled(Headline)`
  ${marginCss};
  margin-top: 0;

  font-weight: 700;
  line-height: 1.25;
  font-size: ${scale110};
`;

export const StyledFiltersForm = styled(FiltersForm)`
  ${marginCss};
`;
